import { useContext } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';

import { AnalyticsContext } from 'contexts/analytics';
import ExportButton from '../ExportButton';
import { usePageExportGenerate } from './usePageExportGenerate';

const ExportPageButton = (): JSX.Element | null => {
  const { dashboardAnalyticsPageExport } = useFlags() || {};

  const { fetching, fetchingCounters, fetchingTabCounters, entitiesTable } =
    useContext(AnalyticsContext);
  const isPageLoading = Boolean(
    fetching || fetchingCounters || fetchingTabCounters || entitiesTable?.loading
  );

  const { requestExport, warningModal, hostElement, isBusy, isDisabled } = usePageExportGenerate();

  if (!dashboardAnalyticsPageExport) return null;

  return (
    <>
      <ExportButton
        variant="primary"
        size="responsive"
        menuPlacement="bottomRight"
        label="Export page"
        loadingLabel="Exporting page"
        disabled={isPageLoading || isDisabled}
        isLoading={isBusy}
        data-testid="export-page-button"
        items={[
          {
            key: 'pdf',
            label: 'Export as PDF',
            icon: 'PdfExport',
            onClick: () => requestExport('pdf'),
            'data-testid': 'export-page-pdf-item',
          },
          {
            key: 'zip',
            label: 'Export as PNG and CSV (ZIP)',
            icon: 'ZipExport',
            onClick: () => requestExport('zip'),
            'data-testid': 'export-page-zip-item',
          },
        ]}
      />
      {warningModal}
      {hostElement}
    </>
  );
};

export default ExportPageButton;
